import { generateUniqueID } from "../utils/generateUniqueID";
import img from "../assets/_home/collection_image.svg";

export const trending = [
  {
    id: generateUniqueID(),
    img: img,
    name: "Cryptographics",
    price: "19,769.39",
    blockchain: "SOL",
    percentage: "+26.52%",
  },
  {
    id: generateUniqueID(),
    img: img,
    name: "Cryptographics",
    price: "19,769.39",
    blockchain: "SOL",
    percentage: "+26.52%",
  },
  {
    id: generateUniqueID(),
    img: img,
    name: "Cryptographics",
    price: "19,769.39",
    blockchain: "SOL",
    percentage: "+26.52%",
  },
  {
    id: generateUniqueID(),
    img: img,
    name: "Cryptographics",
    price: "19,769.39",
    blockchain: "SOL",
    percentage: "+26.52%",
  },
  {
    id: generateUniqueID(),
    img: img,
    name: "Cryptographics",
    price: "19,769.39",
    blockchain: "SOL",
    percentage: "+26.52%",
  },
  {
    id: generateUniqueID(),
    img: img,
    name: "Cryptographics",
    price: "19,769.39",
    blockchain: "SOL",
    percentage: "+26.52%",
  },
  {
    id: generateUniqueID(),
    img: img,
    name: "Cryptographics",
    price: "19,769.39",
    blockchain: "SOL",
    percentage: "+26.52%",
  },
  {
    id: generateUniqueID(),
    img: img,
    name: "Cryptographics",
    price: "19,769.39",
    blockchain: "SOL",
    percentage: "+26.52%",
  },
  {
    id: generateUniqueID(),
    img: img,
    name: "Cryptographics",
    price: "19,769.39",
    blockchain: "SOL",
    percentage: "+26.52%",
  },
  {
    id: generateUniqueID(),
    img: img,
    name: "Cryptographics",
    price: "19,769.39",
    blockchain: "SOL",
    percentage: "+26.52%",
  },
  {
    id: generateUniqueID(),
    img: img,
    name: "Cryptographics",
    price: "19,769.39",
    blockchain: "SOL",
    percentage: "+26.52%",
  },
  {
    id: generateUniqueID(),
    img: img,
    name: "Cryptographics",
    price: "19,769.39",
    blockchain: "SOL",
    percentage: "+26.52%",
  },
  {
    id: generateUniqueID(),
    img: img,
    name: "Cryptographics",
    price: "19,769.39",
    blockchain: "SOL",
    percentage: "+26.52%",
  },
  {
    id: generateUniqueID(),
    img: img,
    name: "Cryptographics",
    price: "19,769.39",
    blockchain: "SOL",
    percentage: "+26.52%",
  },
  {
    id: generateUniqueID(),
    img: img,
    name: "Cryptographics",
    price: "19,769.39",
    blockchain: "SOL",
    percentage: "+26.52%",
  },
  {
    id: generateUniqueID(),
    img: img,
    name: "Cryptographics",
    price: "19,769.39",
    blockchain: "SOL",
    percentage: "+26.52%",
  },
];
